export default "__VITE_ASSET__0a429888__"